// The lobby is embedded cross-site by operator launchers, so on https its cookies
// need SameSite=None;Secure to be readable inside the iframe, and Partitioned (CHIPS)
// keys them to the embedding site so they can't follow a player across operators.
// SameSite=None requires Secure, which needs https, so plain-http dev stays on Lax.
export function cookieAttributes(protocol = globalThis.location.protocol) {
  return protocol === "https:" ? ";SameSite=None;Secure;Partitioned" : ";SameSite=Lax";
}

export function setCookie(cname, cvalue) {
  let d = new Date();
  d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + cookieAttributes();
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.startsWith(' ')) {
      c = c.substring(1);
    }
    if (c.startsWith(name)) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}